import { useEffect, useRef, useState } from 'react';

const useCountdown = (durationSeconds: number, intervalSeconds: number = 1, completeHandler?: () => void) => {
  const timerRef = useRef<NodeJS.Timeout>(undefined);
  const [countdown, setCountdown] = useState(durationSeconds);

  useEffect(() => {
    clearTimeout(timerRef.current);
    if (countdown === 0) {
      if (completeHandler) completeHandler();
      return;
    }

    timerRef.current = setTimeout(() => {
      setCountdown((count) => count - intervalSeconds);
    }, intervalSeconds * 1000);

    return () => {
      clearTimeout(timerRef.current);
    };
  }, [completeHandler, countdown, intervalSeconds]);

  return countdown;
};

export default useCountdown;
